export default __webpack_public_path__ + "static/benifitImg-0da5d386b3c5f5325e52aa852d1269a0.png";